import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Sparkles, Phone, ExternalLink } from 'lucide-react';
export function PitchPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (hasBeenDismissed) return;
      const scrollPosition = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      if (scrollPosition > (documentHeight - windowHeight) / 2) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasBeenDismissed]);
  const handleClose = () => {
    setIsVisible(false);
    setHasBeenDismissed(true);
  };
  return <AnimatePresence data-id="element-107">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 40,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      bounce: 0.3,
      duration: 0.6
    }} className="fixed bottom-6 right-6 z-50 max-w-[380px] w-[calc(100%-3rem)]" data-id="element-108">
          <div className="bg-white rounded-3xl p-6 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] border border-slate-100 relative overflow-hidden" data-id="element-109">
            {/* Decorative top border */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-slate-200 to-slate-300" data-id="element-110"></div>

            <button onClick={handleClose} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors bg-slate-50 hover:bg-slate-100 rounded-full p-1.5" data-id="element-111">
              <X size={16} strokeWidth={2} data-id="element-112" />
            </button>

            <div className="flex items-center gap-3 mb-4" data-id="element-113">
              <div className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-700 border border-slate-100" data-id="element-114">
                <Sparkles size={20} data-id="element-115" />
              </div>
              <h3 className="font-bold text-slate-900 text-lg" data-id="element-116">
                Сподобався сайт?
              </h3>
            </div>

            <p className="text-slate-600 text-sm leading-relaxed mb-6" data-id="element-117">
              Цей сайт ми можемо зробити для вас повністю під ключ, адаптувати
              під усі ваші потреби. Вартість сайту під ключ —{' '}
              <span className="font-bold text-slate-900 bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-118">
                лише 8 000 грн
              </span>
              .
            </p>

            <div className="space-y-2.5" data-id="element-119">
              <a href="tel:+380508399309" className="flex items-center justify-center gap-2 w-full bg-slate-900 hover:bg-slate-800 text-white py-3 rounded-xl text-sm font-semibold transition-colors" data-id="element-120">
                <Phone size={16} data-id="element-121" />
                +38 050 839 93 09
              </a>
              <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-slate-50 hover:bg-slate-100 text-slate-700 border border-slate-200 py-3 rounded-xl text-sm font-semibold transition-colors" data-id="element-122">
                <ExternalLink size={16} data-id="element-123" />
                jetly.agency/ua
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}